var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bitmap',{directives:[{name:"images-loaded",rawName:"v-images-loaded",value:(_vm.onLoaded),expression:"onLoaded"}],staticClass:"c-delayed-bitmap",class:{
    'c-delayed-bitmap-hidden': _vm.isHidden || _vm.hidden,
    'c-delayed-bitmap-visible': !(_vm.isHidden || _vm.hidden)
  },attrs:{"natural-width":_vm.naturalWidth,"natural-height":_vm.naturalHeight,"src":_vm.src,"title":_vm.title},on:{"click":_vm.onClick}})}
var staticRenderFns = []

export { render, staticRenderFns }